import { DcsTabsComponent } from "./dcs-tabs.component";
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [DcsTabsComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [DcsTabsComponent],
})
export class DcsTabsModule { }